<template>
  <div>
    <transition
      enter-active-class="transition-opacity duration-200"
      leave-active-class="transition-opacity duration-200"
      enter-class="opacity-0"
      leave-to-class="opacity-0"
      mode="out-in"
    >
      <Cargando v-if="isLoading" />
      <div v-else class="space-y-2">
        <div class="font-medium">Comprobantes asociados a la factura {{ factura }}</div>
        <div v-if="!error && comprobantes.length > 0" class="flex flex-wrap gap-4">
          <CardComprobante
            v-for="comprobanteTerceros in comprobantes"
            :key="comprobanteTerceros.id"
            :comprobanteTerceros="comprobanteTerceros"
            @refresh="fetchComprobantes"
          />
        </div>
        <div v-else class="italic text-gray-700">No hay información</div>
      </div>
    </transition>
  </div>
</template>

<script>
import { useService } from '@colescba/app-vue'
import { useSession } from '@colescba/ui'

import Cargando from '@/components/Core/Cargando'
import CardComprobante from './CardComprobante'

export default {
  components: { Cargando, CardComprobante },

  props: {
    facturaCodigo: { type: String, required: true },
    facturaNumero: { type: [String, Number], required: true },
    sede: { type: Object, required: true },
  },

  mixins: [useService('portalPagos'), useSession()],

  data() {
    return {
      comprobantes: [],
      error: false,
      isLoading: true,
    }
  },

  async mounted() {
    this.fetchComprobantes()
  },

  computed: {
    factura() {
      return `${this.facturaCodigo.trim().toUpperCase()} ${this.facturaNumero}`
    },
  },

  methods: {
    async fetchComprobantes() {
      this.error = null
      this.isLoading = true
      try {
        this.comprobantes = await this.portalPagos.findComprobantesPorFactura(
          this.user.cuitCuil.numero,
          {
            factu_codi: this.facturaCodigo.trim(),
            factu_nume: this.facturaNumero,
            uso_id: 'USADO',
            sede_id: this.sede.id.trim(),
          }
        )
      } catch (error) {
        console.log(error)
        this.error = error
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
